import { City } from './types';

export const mediumCities: City[] = [
  { name: "Cicero", population: 83889, rank: 11 },
  { name: "Bloomington", population: 78680, rank: 12 },
  { name: "Arlington Heights", population: 75634, rank: 13 },
  { name: "Evanston", population: 74486, rank: 14 },
  { name: "Schaumburg", population: 74227, rank: 15 },
  { name: "Bolingbrook", population: 73936, rank: 16 },
  { name: "Palatine", population: 69350, rank: 17 },
  { name: "Skokie", population: 67824, rank: 18 },
  { name: "Des Plaines", population: 58364, rank: 19 },
  { name: "Orland Park", population: 56767, rank: 20 },
  { name: "Tinley Park", population: 56668, rank: 21 },
  { name: "Oak Lawn", population: 56087, rank: 22 },
  { name: "Berwyn", population: 56025, rank: 23 },
  { name: "Mount Prospect", population: 54771, rank: 24 },
  { name: "Normal", population: 54742, rank: 25 }
];